export default "https://statics.cloudfastin.top/static/v1.27.18.3/store/images/ebaybackground.png?f096c55b01ee07b3918c8a9414dc0e2b";